export default __webpack_public_path__ + "static/media/SL_Icon.7b2bad48.svg";